import { Component, OnDestroy, OnInit, QueryList, ViewChildren } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgxSpinnerService } from 'ngx-spinner';
import { AppointmentCommunicationRequestModel } from 'projects/Administration/src/app/business-entities/appointment-communication-model';
import { NgbdSortableHeader, SortEvent } from 'projects/Autofacets-Core/src/app/directives/sortable.directive';
import { EditAppointmentService } from 'projects/Administration/src/app/business-services/edit-appointment.service';
import { LogofSmsEmailSentDataService } from 'projects/Administration/src/app/data-services/logof-sms-email-sent-data.service';

@Component({
  selector: 'app-appointment-communication',
  templateUrl: './appointment-communication.component.html',
  styleUrls: ['./appointment-communication.component.css']
})
export class AppointmentCommunicationComponent implements OnInit, OnDestroy {
  //#region Declaration
  @ViewChildren(NgbdSortableHeader) headers: QueryList<NgbdSortableHeader>;
  lstCommunication: any[];
  commRequestModel: AppointmentCommunicationRequestModel = {
    AppointmentId: 0,
    ChannelType: 'SELECT',
    StartRecordNo: 0,
    NoOfRecord: 25,
    SortColumn: 'OnDate',
    SortDirection: 'DESC'
  };
  lstChannelType: { id: string, label: string }[] = [
    { id: 'SELECT', label: 'lblSelect' },
    { id: 'EMAIL', label: 'lblEmail' },
    { id: 'SMS', label: 'lblSms' },
    { id: 'PUSHNOTIFICATION', label: 'lblPushNotification' }
  ];
  totalCount: number = 0;
  throttle = 100;
  scrollDistance = 1;
  communicationDetail: any;
  //#endregion

  //#region Constructor & Init
  constructor(private smsEmailLogService: LogofSmsEmailSentDataService,
    private spinner: NgxSpinnerService,
    private modalService: NgbModal,
    private editAppointmentService: EditAppointmentService,
    private activeModal: NgbActiveModal
  ) { }

  ngOnInit(): void {
    this.lstCommunication = [];
    this.commRequestModel.AppointmentId = this.editAppointmentService.appointmentDetails.id;
    this.GetCommunicationList();
  }
  ngOnDestroy(): void {
    this.commRequestModel = null;
    this.lstCommunication = [];
    this.totalCount = 0;
  }
  //#endregion

  //#region Page Method
  async onSort({ column, direction }: SortEvent) {
    // resetting other headers
    this.headers.forEach(header => {
      if (header.sortable !== column) {
        header.direction = '';
      }
    });
    this.commRequestModel.SortColumn = column;
    this.commRequestModel.SortDirection = direction;
    this.commRequestModel.StartRecordNo = 0;
    this.lstCommunication = [];
    this.totalCount = 0;
    await this.GetCommunicationList();
  }
  onScrollDown(_ev) {
    if(this.totalCount > this.lstCommunication.length){
      this.commRequestModel.StartRecordNo = this.lstCommunication.length;
      this.GetCommunicationList();
    }
  }
  onChannelChange(type: string){
    this.commRequestModel.ChannelType = type;
    this.commRequestModel.StartRecordNo = 0;
    this.lstCommunication = [];
    this.totalCount = 0;
    this.GetCommunicationList();
  }

  getLocalDate(date){
    return new Date(date+"Z");
  }

  OnClose() {
    this.activeModal.close({success: false});
  }
  ViewDetails(viewDetailContent, com){
    this.communicationDetail = com;
    let modalRef = this.modalService.open(viewDetailContent, {ariaLabelledBy: 'modal-basic-title', size: 'lg'});
    modalRef.result.then(() => {
      this.communicationDetail = null;
    });
  }
  //#endregion

  //#region API Method
  async GetCommunicationList() {
    this.spinner.show();
    await this.smsEmailLogService.GetAppointmentCommunicationList(this.commRequestModel).then((res) => {
      if (res.responseObject?.length > 0) {
        this.lstCommunication.push(...res.responseObject);
        this.totalCount = this.lstCommunication[0].totalCount;
      }
    }).finally(()=>{
      this.spinner.hide();
    });
  }
  //#endregion
}
